import { PageType } from "@product/scmp-sdk";

export const pathname = "/spotlight";

export const page = {
  route(query: QueryParameters<{ page: "series" | "spotlight" }>) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Series },
    };
  },
};
